var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconMiniArrowDoubleLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconMiniArrowDouble",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1319.1 790.054 1020.06 355.79c-33.165-48.165-87.553-47.273-120.104 0L600.92 790.054c-33.166 48.165-12.581 87.21 46.116 87.21h625.944c58.64 0 78.67-39.938 46.12-87.21ZM600.634 1129.94l299.035 434.27c33.167 48.16 87.554 47.27 120.101 0l299.04-434.27c33.17-48.16 12.58-87.21-46.12-87.21H646.75c-58.636 0-78.668 39.94-46.116 87.21Z"
    })));
  }
}
IconMiniArrowDoubleLine.glyphName = 'mini-arrow-double';
IconMiniArrowDoubleLine.variant = 'Line';
IconMiniArrowDoubleLine.displayName = 'IconMiniArrowDoubleLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconMiniArrowDoubleLine.propTypes = {
  ...SVGIcon.propTypes
};
IconMiniArrowDoubleLine.allowedProps = [...SVGIcon.allowedProps];
export default IconMiniArrowDoubleLine;
export { IconMiniArrowDoubleLine };